import { render, staticRenderFns } from "./news-card.vue?vue&type=template&id=4bdf8037&scoped=true&"
import script from "./news-card.vue?vue&type=script&lang=js&"
export * from "./news-card.vue?vue&type=script&lang=js&"
import style0 from "./news-card.vue?vue&type=style&index=0&id=4bdf8037&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf8037",
  null
  
)

export default component.exports